import i18next from 'i18next'
import getUserLanguage from 'src/utils/getUserLanguage'

const options = { ns: getUserLanguage() }

export const MOUNT_SELECTOR = '.vue-banner-mtlink-mount'

export const BLOCK_NAME = 'mtlink-banner'

export const CLASS_NAMES = {
  triggerOpenPopup: `${BLOCK_NAME}__js-open-popup`,
}

export const SLIDES_DATA = [
  {
    name: i18next.t('Добавляйте в медкарту заключения и анализы', options),
    src: '/static/_v1/pd/screenshots/medtochka/medtochka-app-medcard-add-docs-qr.png',
    attributes: [{
      name: i18next.t('Добавляйте в медкарту заключения <br>и анализы', options),
    }],
  },
  {
    name: i18next.t('На приёме врач посмотрит всё на компьютере', options),
    src: '/static/_v1/pd/screenshots/medtochka/medtochka-app-medcard-see-desktop-qr.png',
    attributes: [{
      name: i18next.t('На приёме врач посмотрит всё <br>на компьютере', options),
    }],
  },
]
